import React from "react";
import { cleanJoin } from "../../../../utils/stringUtil";

function Step({ isActive, render }) {
  return (
    <div className={cleanJoin("step", "is-size-5", !isActive ? "is-hidden" : null)}>
      {render && render()}
    </div>
  );
}

export default Step;
